module.exports = __webpack_public_path__ + "img/motec-logo-print.3e19d14.webp";